import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../../_models/api-response.model';
import { AgentList, AvailableAgentsResponse } from '../../_models/agent.model';

@Injectable({
    providedIn: 'root'
})
export class OfferAgentService {
    private adminApiUrl = `${environment.apiUrl}/admin/reservations`;

    constructor(private http: HttpClient) { }

    getAvailableAgents(
        reservationId: number,
        search?: string,
        specialization?: string
    ): Observable<ApiResponse<AvailableAgentsResponse>> {
        let params = new HttpParams();
        
        if (search) {
        params = params.set('search', search);
        }
        if (specialization) {
        params = params.set('specialization', specialization);
        }

        return this.http.get<ApiResponse<AvailableAgentsResponse>>(
        `${this.adminApiUrl}/${reservationId}/available-agents`,
        { params }
        );
    }

    assignAgentToOffer(
        offerId: number,
        agentId: number
    ): Observable<ApiResponse<void>> {
        const assignmentDTO = { agentId };
        
        return this.http.post<ApiResponse<void>>(
        `${this.adminApiUrl}/offers/${offerId}/assign-agent`,
        assignmentDTO
        );
    }

    removeAgentFromOffer(
        offerId: number,
        agentId: number
    ): Observable<ApiResponse<void>> {
        return this.http.delete<ApiResponse<void>>(
        `${this.adminApiUrl}/offers/${offerId}/assign-agent/${agentId}`
        );
    }

    getAssignedAgentsForOffer(
        offerId: number
    ): Observable<ApiResponse<AvailableAgentsResponse>> {
        return this.http.get<ApiResponse<AvailableAgentsResponse>>(
        `${this.adminApiUrl}/offers/${offerId}/assigned-agents`
        );
    }
}